<template>
  <v-layout row wrap>
    <!--<v-flex xs4>
      <v-btn color="primary" dark>Total Income
        {{$app.formatMoney(100000)}}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs4>
      <v-btn color="accent" dark>Total Blocked
        {{$app.formatMoney(100000)}}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs4>
      <v-btn color="success" dark>Total Blocked
        {{$app.formatMoney(100000)}}
        <v-icon dark right>check_circle</v-icon>
      </v-btn>
    </v-flex>-->
    <v-flex xs12>
      <stats-card url="income" chart-type="bar" title="Income Per Month"></stats-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import StatsCard from './StatsCard'

  export default {
    name: 'AdminDashboard',
    components: {StatsCard}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AdminDashboard.vue